module.exports = __webpack_public_path__ + "assets/a9e464778bc45900a411ded70e4cc793.png";